import { ChangeDetectorRef, Component, ErrorHandler, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { AuthenticationService } from '../shared/auth/authentication.service';
import { loadAppConfiguration, loadBrandingConfiguration } from '../shared/app-configuration/app-configuration.actions';
import { IRootState } from './app.config';
import { Store } from '@ngrx/store';
import { AsyncPipe } from '@angular/common';
import { LoadingComponent } from './loading/loading.component';
import { ToastContainerComponent } from "../shared/toaster/toast-container/toast-container.component";
import { loadUserConfiguration } from '../shared/user/user.actions';
import { LoggingService } from '../shared/logging/logging.service';
import { ErrorHandlerService } from '../shared/error-handler/error-handler.service';
import { StateProvider } from '@bryntum/grid';
import { BryntumGridModule } from '@bryntum/grid-angular';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  standalone: true,
  imports: [ReactiveFormsModule, RouterOutlet, LoadingComponent, AsyncPipe, ToastContainerComponent, BryntumGridModule],
  providers: [AuthenticationService, LoggingService, { provide: ErrorHandler, useClass: ErrorHandlerService }]
})
export class AppComponent implements OnInit {

  constructor(
    private store$: Store<IRootState>,
    private cd: ChangeDetectorRef,
    private loggingService: LoggingService,
    private router: Router) { 
      StateProvider.setup('memory');
    }

  ngOnInit(): void {
    this.loggingService.logEvent("App Initialised");
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const url = event.urlAfterRedirects;
        this.loggingService.logPageView(undefined, url);
      }
    });
  }

  title = 'Mogo Portal';
}
